import axios from 'axios';
import { logoutUser, refreshaccess } from '../features/user/userSlice';
import store from '../store/store';
import { startLoading, stopLoading } from '../features/misc/loadingSlice';
import i18n from '../i18n';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // URL base de tu API en Django
});

API.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};
    config.headers['Accept-Language'] = i18n.language || 'es';
    
    if(config.headers.Authorization){
      const state = store.getState();
      const { access, refresh } = state.user;

      if (access) {
        config.headers.Authorization = `Bearer ${access}`;
      }
      const expirationTime = getTokenExpiration(access);
      if (expirationTime && expirationTime < Date.now()) {
        try {
          const result = await store.dispatch(refreshaccess(refresh));
          if (result.meta.requestStatus === 'fulfilled') {
            config.headers.Authorization = `Bearer ${result.payload.access}`;
          }
        } catch (error) {
          console.error('Error refreshing token', error);
          store.dispatch(logoutUser());
        }
      }else{
        store.dispatch(startLoading());
      }
    }else{
      store.dispatch(startLoading());
    }

    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

const getTokenExpiration = (token: string | null): number | null => {
  if (!token) return null;
  const [, payload] = token.split('.');
  const decodedPayload = JSON.parse(atob(payload));
  return decodedPayload.exp * 1000;
};


export default API;
